export default __webpack_public_path__ + "static/media/download_white.bf743e5d.svg";